module.exports = __webpack_public_path__ + "static/media/12UNCTAD13.be8f2c62.jpg";